export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11292.e914076f.jpg";